import React from 'react';
import { RiskClassification } from '../../../../../types/AISystems.types';
import { RiskClassificationProps } from './RiskClassification.types';

const RiskClassificationComponent: React.FC<RiskClassificationProps> = ({
  riskType,
  className = '',
}) => {
  const getRiskClasses = (risk: string | null) => {
    const baseClasses =
      'font-inter font-medium text-xs leading-4 text-center px-2 py-1 rounded-full inline-block min-w-20 whitespace-nowrap';

    switch (risk) {
      case RiskClassification.HIGH_RISK:
        return `${baseClasses} text-orange-700 bg-orange-100`;
      case RiskClassification.HIGH_RISK_EXCEPTION:
        return `${baseClasses} text-orange-700 bg-orange-100`;
      case RiskClassification.PROHIBITED:
        return `${baseClasses} text-rose-700 bg-rose-100`;
      case RiskClassification.LIMITED_RISK:
        return `${baseClasses} text-amber-700 bg-amber-100`;
      case RiskClassification.MINIMAL_RISK:
        return `${baseClasses} text-cyan-700 bg-cyan-100`;
      case RiskClassification.AUTHORISED:
        return `${baseClasses} text-cyan-700 bg-cyan-100`;
      case RiskClassification.PRODUCT_MANUFACTURER:
        return `${baseClasses} text-cyan-700 bg-cyan-100`;
      case RiskClassification.OUT_OF_SCOPE:
        return `${baseClasses} text-gray-800 bg-gray-100`;
      case RiskClassification.EXCLUDED:
        return `${baseClasses} text-gray-800 bg-gray-100`;
      default:
        return ``;
    }
  };

  const getRiskLabel = (risk: string | null) => {
    switch (risk) {
      case RiskClassification.HIGH_RISK:
        return 'High-Risk';
      case RiskClassification.HIGH_RISK_EXCEPTION:
        return 'High-Risk Exception';
      case RiskClassification.PROHIBITED:
        return 'Prohibited';
      case RiskClassification.LIMITED_RISK:
        return 'Limited-Risk';
      case RiskClassification.MINIMAL_RISK:
        return 'Minimal-Risk';
      case RiskClassification.AUTHORISED:
        return 'Authorised repres...';
      case RiskClassification.OUT_OF_SCOPE:
        return 'Out of Scope';
      case RiskClassification.EXCLUDED:
        return 'Excluded';
      case RiskClassification.PRODUCT_MANUFACTURER:
        return 'Product manufacturer';
      default:
        return risk || 'Unknown';
    }
  };

  const classes = getRiskClasses(riskType);
  const label = getRiskLabel(riskType);

  return (
    <span
      className={`${classes} ${className}`}
      role="status"
      aria-label={`Risk classification: ${label}`}
    >
      {label}
    </span>
  );
};

export default RiskClassificationComponent;
